export default function GrowthIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.63665 16.3837C4.94394 16.5634 5.31217 16.5089 5.55597 16.2504L8.75075 12.8264C8.9336 12.6304 9.22819 12.6304 9.41104 12.8264L11.1811 14.7235C11.5367 15.1045 12.0039 15.3631 12.5093 15.3957C13.0883 15.4338 13.6369 15.2106 14.0432 14.7752L18.2233 10.2951V12.6331C18.2233 13.0768 18.5255 13.4524 18.909 13.4932C19.1731 13.5204 19.4271 13.4034 19.5947 13.172C19.6988 13.0278 19.7471 12.8427 19.7471 12.6603V9.41599C19.7471 8.36266 18.9522 7.51074 17.9694 7.51074H14.9651C14.5511 7.51074 14.2007 7.83463 14.1626 8.24562C14.1372 8.53141 14.2438 8.80086 14.4622 8.9805C14.5968 9.09209 14.7695 9.14381 14.9422 9.14381H17.1466L12.9664 13.6239C12.7836 13.8198 12.489 13.8198 12.3061 13.6239L10.5361 11.7268C10.1805 11.3457 9.7107 11.0872 9.20787 11.0545C8.62885 11.0164 8.0803 11.2396 7.67397 11.6751L4.44872 15.1317C4.33952 15.2488 4.26587 15.4039 4.25571 15.5699C4.2354 15.9183 4.38777 16.2449 4.63665 16.3892V16.3837Z"
				fill="currentColor"
			/>
		</svg>
	);
}
